import { Model } from "@bryntum/schedulerpro";
import { TAGS_KEYS } from "../../other/constants/TagsKeys.jsx";

// tagSet could be "category", "tag", "status"
export class ResourceTagValues extends Model {
  static get $name() {
    return "ResourceTagValues";
  }

  static get fields() {
    return [{ name: "tagSet", dataSource: "tag_set" }, "order", { name: "tagValue", dataSource: "value" }];
  }

  get tagValue() {
    return this.get("tagValue");
  }

  set tagValue(val) {
    if (this.get("tagSet") === TAGS_KEYS.icon) {
      this.set("tagValue", val.toLowerCase());
    } else {
      this.set("tagValue", val);
    }
  }
}

ResourceTagValues.exposeProperties();
